import React, { useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Research from './components/Research';
import Publications from './components/Publications';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [publications, setPublications] = useState([]);
  const [pubError, setPubError] = useState(false);

  useEffect(() => {
    fetch('https://api.openalex.org/works?filter=author.id:A5073569092')
      .then((res) => res.json())
      .then((data) => {
        if (data && Array.isArray(data.results)) {
          setPublications(data.results);
        } else {
          setPubError(true);
        }
      })
      .catch(() => setPubError(true));
  }, []);

  const pub = process.env.PUBLIC_URL;

  return (
    <>
      <Navbar />
      <Home pub={pub} />
      <Research pub={pub} />
      <Publications publications={publications} pubError={pubError} />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
